import { useDeleteRoleMutation } from '../../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useRemoveRoleHandler( options?: any ) {
	const [ removeRole ] = useDeleteRoleMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( roleId: number ) => {
		const { data } = await removeRole( { variables: { roleId } } )

		if ( data?.deleteRole?.success ) {
			showSuccess( `removeRoleSuccess${Date.now()}`, data?.deleteRole?.message ?? 'Successfully removed role!' )
		} else {
			showError( `removeRoleError${Date.now()}`, data?.deleteRole?.message ?? 'Sorry, an error occurred' )
		}
	}
}
